import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { NewProjectFormValues } from './AddProjectDialog';

export const NewProjectStep = () => {

  const { formatMessage } = useIntl();
  const { control } = useFormContext<NewProjectFormValues>();

  return (<>
    <Controller
      control={control}
      name='name'
      rules={{ required: formatMessage({ id: 'This field is required' }) }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          autoFocus
          {...field}
          required
          label={formatMessage({ id: 'Name' })}
          error={Boolean(error)}
          helperText={error?.message}
        />
      )}
    />

    <Controller
      control={control}
      name='description'
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={formatMessage({ id: 'Description' })}
          error={Boolean(error)}
          helperText={error?.message}
        />
      )}
    />
  </>
  );
};